<template>
  <section id="homeThankYouSreen">
    <div class="container">
      <div class="logo">
        <img :src="`${publicPath}img/shaves_logo.svg`" alt>
      </div>
      <div class="textCopy">
        <h4>We're all done – thanks for signing up</h4>
        <h2>Ready to go digital?</h2>
        <p class="primary">Add your card to your Apple or Google wallet</p>
        <div class="actions">
          <RouterLink :to="`/digital-loyalty?email=${encodeURIComponent(email)}&signup=true`" class="button is-large is-outlined">
            Add to Wallet
          </RouterLink>
        </div>
        <p>This registration will close & clear all information in {{secondsRemaining}} seconds</p>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  name: "individualthankyou",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      email: this.$store.state.personal.info.email,
      secondsRemaining: 20
    };
  },
  methods: {},
  mounted() {
    // setInterval(() => {
    //   this.secondsRemaining -= 1;
    //   if (this.secondsRemaining == 0) {
    //     this.$router.push("/");
    //   }
    // }, 1000);
  }
};
</script>
